import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/motion";
import { usePageMeta } from "@/lib/seo";
import { useLang } from "@/i18n/LanguageContext";

export const TermsOfUse = () => {
    const { t } = useLang();
    const SECTIONS = [
        {
            h: t("terms.s1.h", "1. Acceptance of terms"),
            p: [
                t("terms.s1.p1", "By using this website or engaging UniversHeal's coordination services, you agree to these Terms of Use. If you do not agree, please do not use the website."),
            ],
        },
        {
            h: t("terms.s2.h", "2. What we provide"),
            p: [
                t("terms.s2.p1", "UniversHeal provides healthcare coordination services: helping international patients connect with appropriate specialists and healthcare providers in India, understand treatment options, and coordinate the practical parts of their healthcare journey."),
                t("terms.s2.p2", "UniversHeal is not a hospital, clinic or medical provider, and does not itself diagnose, treat or provide medical care. Medical services are delivered by independent third-party hospitals and clinicians."),
            ],
        },
        {
            h: t("terms.s3.h", "3. No medical advice"),
            p: [
                t("terms.s3.p1", "Content on this website is provided for general information only. It is not medical advice and must not be relied upon as a substitute for consultation with a qualified medical professional. Always seek the advice of your doctor regarding any medical condition or treatment."),
            ],
        },
        {
            h: t("terms.s4.h", "4. Third-party providers"),
            p: [
                t("terms.s4.p1", "Hospitals, specialists, laboratories, transport providers and accommodation partners are independent businesses. We coordinate with them on your behalf but do not own or control them, and we are not responsible for the medical care or services they deliver."),
            ],
        },
        {
            h: t("terms.s5.h", "5. Website content and intellectual property"),
            p: [
                t("terms.s5.p1", "All content on this website — text, design, graphics and the UniversHeal brand — belongs to UniversHeal or its licensors and may not be copied or used without permission, except for personal, non-commercial reference."),
            ],
        },
        {
            h: t("terms.s6.h", "6. Limitation of liability"),
            p: [
                t("terms.s6.p1", "To the maximum extent permitted by law, UniversHeal is not liable for indirect or consequential losses arising from use of this website or from medical services delivered by third-party providers. Nothing in these terms limits liability that cannot be limited by law."),
            ],
        },
        {
            h: t("terms.s7.h", "7. Privacy"),
            p: [
                t("terms.s7.p1", "Your use of this website is also governed by our Privacy Policy, which explains how we handle personal and health-related information."),
            ],
        },
        {
            h: t("terms.s8.h", "8. Changes"),
            p: [
                t("terms.s8.p1", "We may update these terms from time to time. Continued use of the website after changes are published constitutes acceptance of the updated terms."),
            ],
        },
        {
            h: t("terms.s9.h", "9. Governing terms"),
            p: [
                t("terms.s9.p1", "[Placeholder — governing law and jurisdiction provisions will be specified before launch.]"),
            ],
        },
    ];
    usePageMeta(
        t("meta.terms_of_use.title", "Terms of Use"),
        t("meta.terms_of_use.desc", "Terms governing the use of the UniversHeal website and healthcare coordination services for international patients.")
    );
    return (
        <>
            <PageHero
                eyebrow={t("legal.eyebrow", "Legal")}
                title={t("terms.title", "Terms of Use")}
                intro={t("terms.intro", "The terms that govern your use of this website and our coordination services.")}
            />
            <section className="section-pad pt-6">
                <div className="container-site max-w-3xl">
                    <Reveal>
                        <p className="text-xs leading-relaxed text-moss bg-sage/70 border border-pine/10 rounded-2xl px-5 py-4 mb-12">
                            {t("legal.draftNote", "[Draft for review before launch — Last updated: placeholder date.]")}
                        </p>
                    </Reveal>
                    {SECTIONS.map((s, si) => (
                        <Reveal key={si}>
                            <div className="mb-10" data-testid={`terms-${si + 1}`}>
                                <h2 className="font-serif font-medium text-2xl sm:text-3xl text-forest">
                                    {s.h}
                                </h2>
                                {s.p.map((para, i) => (
                                    <p
                                        key={i}
                                        className="mt-4 text-[15px] leading-relaxed text-charcoal/80"
                                    >
                                        {para}
                                    </p>
                                ))}
                            </div>
                        </Reveal>
                    ))}
                </div>
            </section>
        </>
    );
};
